import React from 'react';
import { Link } from "react-router-dom";

const getButtonClassesByType = (type) => {
    if (type === 'primary') return 'btn-primary';
    if (type === 'btn-link') return 'btn-link';
    if (type === 'primary-outline') return 'btn-outline-primary';

    if (type === 'secondary') return 'btn-secondary';
    return '';
};

const getConcatenatedElementClassName = (type, classes) => {
    if (!classes.length) return getButtonClassesByType(type);

    return `${getButtonClassesByType(type)} ${classes}`;
};

const Button = ({tag = 'Link', type = '', className = '', children, title, href, clickHandler}) => {
    const classes = `btn ${getConcatenatedElementClassName(type, className)}`;
    const elementProps = {
        className: classes,
        title,
        href,
        to: href,
        onClick: clickHandler,
    };

    if (tag === 'Link') {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return <Link {...elementProps}>{children}</Link>
    }

    return React.createElement(
        tag,
        elementProps,
        children,
    );
};

export default Button;